import { useAsyncEntity } from '../../../../Entity'
import { getMockIntegrationsStatus } from '../../../../RentalPortalListing'

// TODO: read the integrations status endpoint once it exists; until then the
// listing mock's connection fixture serves this page and the Publishings tab.
export function useRentalPortalIntegrationsRead() {
  function getProfileData() {
    return getMockIntegrationsStatus()
  }

  const {
    entityData,
    handleEntityInit,
    handleEntityReload,
    isInitiated,
    isLoading,
    serverError,
  } = useAsyncEntity({ getProfileData })

  return {
    handleReload: handleEntityReload,
    handleRetry: handleEntityInit,
    hasError: Boolean(serverError),
    integrations: entityData,
    isLoading: isLoading || !isInitiated,
  }
}
